import React, { Suspense } from 'react'
import { HashRouter, Route, Redirect, Switch } from 'react-router-dom';
import HeaderMain from './Components/Layout/HeaderMain';
import Footer from './Components/Layout/Footer';
import './Style/style.scss';
import { Charts, Subscription, SubscriptionDetails } from './Screens'
import { routes } from './Routes/Routes';
import { useSelector } from "react-redux";
import AddToHome from './Components/AddToHome';
import Login from './Screens/Out/Login';
// import GoToWebPage from './Components/GoToWebPage'


const App = () => {
	const isLogin = useSelector(
		(state) => state.auth.isLogin
	)

	const isAddedToHome = useSelector(
		(state) => state.persistedParams.isAddedToHome
	);

	// if (window.screen.width > 540 && window.screen.height > 720 ) return <GoToWebPage/> ;

	// if (!isAddedToHome) return <AddToHome />
	if (!isLogin) return <Login />

	return (
		<HashRouter>
			
			<HeaderMain />
			<Suspense fallback={<div></div>}>
				<Switch>
					{routes.map((route, index) => {
						return (
							<Route key={index} path={route.path} name={route.name}
								// component={route.component}
								render={props => (
									<route.component {...props} />
								)}
							/>
						)
					})}
					<Redirect form="/" to="/home" />
				</Switch>
			</Suspense>
			<Footer />
		</HashRouter>
	)
}


export default App
